import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectGroupConfigByClass {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectGroupConfigByClass = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectGroupConfigByClass) => {
  const itemList = useStoreState((state) => state.exam.groupDropdownlist);

  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.groupId === id);
      onChange(value.id);
    }
  };





  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      className="classSelectByGroup"
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Group"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.groupId} value={type.groupId}>
            {type.groupName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Group</Option>
      )}
    </Select>
  );
};
